// Slownik typow parametrow - jedyne miejsce laczace ParamType z bazy z widokiem.
// valueKey wskazuje kolumne bazy ktora czytamy/zapisujemy,
// inputType determinuje jaki input renderujemy w GUI.
// password/url/email/time to warianty inputa - w bazie siedza w ValueChar.

export const PARAM_TYPES = {
  num: { valueKey: "valueNum", inputType: "number" },
  bool: { valueKey: "valueBool", inputType: "switch" },
  char: { valueKey: "valueChar", inputType: "text" },
  text: { valueKey: "valueText", inputType: "textarea" },
  date: { valueKey: "valueDate", inputType: "date" },
  password: { valueKey: "valueChar", inputType: "password" },
  url: { valueKey: "valueChar", inputType: "url" },
  email: { valueKey: "valueChar", inputType: "email" },
  time: { valueKey: "valueChar", inputType: "time" },
};

export const OTHER_GROUP_LABEL = "Pozostałe";

export const getParamTypeDefinition = (paramType) =>
  PARAM_TYPES[paramType?.trim()?.toLowerCase()] ?? null;

// Buduje sekcje widoku z odpowiedzi API. Grupy alfabetycznie,
// parametry bez ParamGroup laduja w "Pozostale" na samym koncu.
export const groupParameters = (parameters) => {
  const groups = new Map();

  parameters.forEach((parameter) => {
    const label = parameter.paramGroup?.trim() || OTHER_GROUP_LABEL;
    if (!groups.has(label)) {
      groups.set(label, []);
    }
    groups.get(label).push(parameter);
  });

  return [...groups.entries()]
    .map(([label, params]) => ({
      label,
      params: [...params].sort((a, b) => (a.paramId ?? '').localeCompare(b.paramId ?? '')),
    }))
    .sort((a, b) => {
      if (a.label === OTHER_GROUP_LABEL) {
        return 1;
      }
      if (b.label === OTHER_GROUP_LABEL) {
        return -1;
      }
      return a.label.localeCompare(b.label);
    });
};
